import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

export default class DigitalSeries {
    constructor(dom) {
        window.addEventListener("resize", () => this.resize());
        this.dom = dom
        this.filter = this.dom.querySelector('.ds-filers')
        this.loading = false

        this.queryValues = {
            'type': '',
            'keywords': '',
            'sortby': '',
            'paged': 1,
        }


        Array.from(this.filter.querySelectorAll('input[type="checkbox"]')).forEach((item, i) => {
            item.addEventListener('change', (e) => {
                // console.log(e.target);
            })
        });

        // when filter form changes
        this.filter.addEventListener('change', (e) => {
            // var formData = new FormData(this.filter);
            // console.log(Object.fromEntries(formData));

            e.preventDefault()
            this.formSubmit(this.filter)
        })

        this.filter.addEventListener('reset', (e) => {
            setTimeout(() => {
                this.formSubmit(e.target)
            }, 10)
        })

        this.filter.addEventListener('submit', (e) => {
            e.preventDefault()
            this.formSubmit(e.target)
        })

        this.initPagination()
    }

    formSubmit(el_form) {
        if (this.loading) {
            return
        }

        this.queryValues = {
            'type': '',
            'keywords': '',
            'sortby': '',
            'paged': 1,
        }

        var formData = new FormData(el_form);
        // output as an object
        console.log(Object.fromEntries(formData));

        // ...or iterate through the name-value pairs
        for (var pair of formData.entries()) {
            // console.log(pair[0] + ": " + pair[1]);
            if (!pair[1]) {
                continue
            }
            let key = ''
            let val = ''
            switch (pair[0]) {
                case 'categories[]':
                    key = 'categories'
                    this.queryValues['categories'].push(pair[1])
                    val = this.queryValues['categories']
                    break;
                default:
                    key = pair[0]   
                    val = pair[1]
                    break;
            }
            this.queryValues[key] = val
            this.historyPushState(key, val)
            // console.log(this.queryValues);
        }

        this.queryValues['paged'] = 1
        this.historyPushState('paged', 1)

        this.fetchData()
    }

    historyPushState(type, val) {
        const url = new URL(window.location);
        url.searchParams.set(type, val);
        window.history.pushState({}, "", url);
    }

    initPagination() {
        const pages = this.dom.querySelectorAll('.pagination--item')
       
        if (pages) {
            pages.forEach((item, i) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()

                    if (this.loading) {
                        return
                    }

                    this.queryValues['paged'] = parseInt(item.dataset.page)
                    this.historyPushState('paged', parseInt(item.dataset.page))
                    this.fetchData()
                })
            });


        }
    }

    fetchData() {

        this.loading = true

        fetch("?www_api=1&cmd=getPodcastItems", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(this.queryValues),
        })
        .then((response) => response.json())
        .then((response) => {
            this.loading = false

            let old_items = document.querySelector("[js-list-items]");
            let old_pagination = document.querySelector("[js-pagination]");

            let new_items = document.createElement("div");
            new_items.innerHTML = response.items.trim();
            let new_pagination = document.createElement("div");
            new_pagination.innerHTML = response.pagination.trim();

            old_items.parentNode.replaceChild(new_items.firstChild, old_items);
            old_pagination.parentNode.replaceChild(new_pagination.firstChild, old_pagination);

            this.initPagination()

            ScrollTrigger.batch(this.dom.querySelectorAll(".podcast-page--content [js-scroll_fadein='batch']"), {
                start: "top 90%",
                invalidateOnRefresh: true,
                // markers: true,
                onEnter: (elements, triggers) => {
                    gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
                    // console.log(elements.length, "elements entered");
                },
                onLeaveBack: (elements, triggers) => {
                    gsap.to(elements, { opacity: 0, y: 40, stagger: 0.15 });
                    // console.log(elements.length, "elements leave back");
                },
            });
            gsap.to(window, { duration: .5,
                scrollTo: {
                    y: ".podcast-page--content",
                    // offsetY: document.querySelector('header').offsetHeight
                }
            });
        })
    }

    init() {

    }

    resize() {

    }

}
